const baseUrl = process.env.REACT_APP_BASE_URL;
const policyBaseUrl = process.env.REACT_APP_POLICY_API_URL;
export const getPeoplePaymentNotificationUrl = `${baseUrl}/payments/notifications/people?payableOnly=true`;
export const getPolicyPeopleUrl = `${policyBaseUrl}/customer/policyholders`;
export const getPolicyPeopleDetailUrl = `${policyBaseUrl}/customer/policyholders`;
export const getDocumentToSignedUrl = `${baseUrl}/media/expectedDocuments/getAllDocuments`;
export const checkRevisionUrl = `${baseUrl}/media/expectedDocuments/checkRevision`;
export const saveToMediaUrl = `${baseUrl}/media/expectedDocuments/v2/saveToMedia/`;
export const getThumbnailUrl = `${baseUrl}/media/policy/thumbnail`;
export const signDocumentV3Url = `${baseUrl}/media/policy/v3/signDocument`;
export const saveImageAndDocumentUrl = `${baseUrl}/media/policy/v3/saveImageAndDocument`;
export const getRegulationsUrl = `${baseUrl}/payments/regulations/getAllRegulations`;
export const getPolicyRegulationsUrl = `${policyBaseUrl}/customer/regulations`;
export const getPolicyRegulationDetailUrl = `${policyBaseUrl}/customer/regulation_details`;
export const getDetailTypeFromParamUrl = `${baseUrl}/payments/regulations/getDetailTypeFromParam`;
export const getAllRefundPremiumUrl = `${baseUrl}/media/refundPremium/getAllRefundPremium`;
export const updateBankRefUrl = `${baseUrl}/profile/user/updateBankRef`;
export const getAllPolicyRefundsUrl = `${policyBaseUrl}/customer/refunds`;
export const sendEmailBankRefUrl = `${baseUrl}/management/profile/sendIbanEmails`;
export const isUpdatedUrl = `${baseUrl}/management/auth/isUpdated`;
export const removeTokenUrl = `${baseUrl}/notifications/notify/removeToken`;
export const userUrl = `${baseUrl}/profile/user`;
export const userInfoUrl = `${baseUrl}/profile/user/info`;
export const userInfoLiteUrl = `${baseUrl}/profile/user/infoLite`;
export const personInfoUrl = `${baseUrl}/profile/user/person`;
export const policyUrl = `${baseUrl}/dashboard/policies`;
export const checkTitlesUrl = `${baseUrl}/dashboard/policies/check`;
export const policyDocumentUrl = `${baseUrl}/media/policy`;
export const titleDocumentUrl = `${baseUrl}/media/policy/title`;
export const policyTitlesHistoryUrl = `${baseUrl}/dashboard/policies/titlesHistory`;
export const peoplePoliciesV2Url = `${baseUrl}/dashboard/policies/v2/people`;
export const policiesUrl = `${policyBaseUrl}/customer/policies`;
export const messagesV2Url = `${baseUrl}/notifications/notify/v2/messages`;
export const resumeUrl = `${baseUrl}/notifications/notify/resume`;
export const archivedUrl = `${baseUrl}/notifications/notify/archive`;
export const updateUrl = `${baseUrl}/notifications/notify/principal`;
export const policyProfileUrl = `${policyBaseUrl}/customer/users/me`;
export const changePasswordUrl = `${policyBaseUrl}/customer/users/password`;
export const policyTypesUrl = `${baseUrl}/dashboard/policies/types`;
export const policyBranchesUrl = `${policyBaseUrl}/customer/users/`;
export const claimsV2Url = `${baseUrl}/claims/v2/claims`;
export const policyClaimsUrl = `${policyBaseUrl}/customer/claims`;
export const claimsUrl = `${baseUrl}/claims`;
export const policyClaimIdUrl = `${policyBaseUrl}/customer/claims`;
export const accountExecUrl = `${baseUrl}/profile/user/accountExec`;
export const countActiveClaimsUrl = `${baseUrl}/claims/v2/countActiveClaims`;
export const paymentUrl = `${baseUrl}/payments/notifications/people?payableOnly=true`;
export const paymentPolicyUrl = `${policyBaseUrl}/customer/notifications`;
export const nexiUrl = `${baseUrl}/payments/notifications/isNexiOrderPaid`;
export const slimPayUrl = `${baseUrl}/payments/notifications/getSlimpayOrderStatus`;
export const generatePaymentUrl = `${baseUrl}/payments/notifications/getPaymentUrl`;
export const slimPayPendingUrl = `${baseUrl}/profile/user/setSlimpayPendingStatus`;
export const paymentReceivedUrl = `${baseUrl}/payments/sendPaymentReceived`;
export const sendUpdatePassUrl = `${baseUrl}/dashboard/policies/sendUpdatePass`;
export const operationCreateOrUpdateUrl = `${baseUrl}/management/operation/createOrUpdate`;
export const operationCompleteUrl= `${baseUrl}/management/operation/complete`;
export const patchBankRef = `${policyBaseUrl}/customer/bank_refs`;
export const policyVehiclesUrl = `${policyBaseUrl}/customer/vehicles`;
export const vehicleInfoUrl = `${baseUrl}/profile/user/vehicleInfo`;
